/**
 * @generated SignedSource<<ffe4349e92e218a00035e8518f76e8bc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type DevOpsPullRequestStatus = "DECLINED" | "DRAFT" | "MERGED" | "OPEN" | "UNKNOWN" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type pullRequestTable_softwareCodePage$data = ReadonlyArray<{
  readonly commentCount: number | null | undefined;
  readonly id: string;
  readonly lastUpdated: AGG$DateTime | null | undefined;
  readonly reviewers: ReadonlyArray<{
    readonly __typename: "DevOpsReviewer";
  } | null | undefined> | null | undefined;
  readonly status: DevOpsPullRequestStatus | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"commentsCell_softwareCodePage" | "lastUpdatedCell_softwareCodePage" | "reviewersCell_softwareCodePage" | "statusCell_softwareCodePage" | "summaryCell_softwareCodePage">;
  readonly " $fragmentType": "pullRequestTable_softwareCodePage";
}>;
export type pullRequestTable_softwareCodePage$key = ReadonlyArray<{
  readonly " $data"?: pullRequestTable_softwareCodePage$data;
  readonly " $fragmentSpreads": FragmentRefs<"pullRequestTable_softwareCodePage">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "pullRequestTable_softwareCodePage",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW",
      "path": "id"
    },
    {
      "kind": "ScalarField",
      "name": "status"
    },
    {
      "kind": "ScalarField",
      "name": "lastUpdated"
    },
    {
      "concreteType": "DevOpsReviewer",
      "kind": "LinkedField",
      "name": "reviewers",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__typename"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "commentCount"
    },
    {
      "kind": "FragmentSpread",
      "name": "summaryCell_softwareCodePage"
    },
    {
      "kind": "FragmentSpread",
      "name": "statusCell_softwareCodePage"
    },
    {
      "kind": "FragmentSpread",
      "name": "reviewersCell_softwareCodePage"
    },
    {
      "kind": "FragmentSpread",
      "name": "commentsCell_softwareCodePage"
    },
    {
      "kind": "FragmentSpread",
      "name": "lastUpdatedCell_softwareCodePage"
    }
  ],
  "type": "DevOpsPullRequestDetails"
};

(node as any).hash = "af49297f29841f09e1896ea99cd6d30b";

export default node;
